module.exports = __webpack_public_path__ + "static/img/p1.40afe86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/colorpop/p1.jpg
// module id = 8klT
// module chunks = 1